export const isHTMLInputEvent = (
  event?: any,
  stopPropagation = true
): event is InputEvent => {
  if (typeof event?.target !== 'object' || !event?.target) return false
  else if ('value' in event.target) return true
  else if ('checked' in event.target) return true
  else if (stopPropagation) event.stopPropagation?.()
  return false
}

export const isHTMLEvent = (event?: any): event is Event =>
  typeof event?.stopPropagation === 'function' &&
  typeof event?.preventDefault === 'function'

export const isHTMLInputEventFromSelf = (event?: any) =>
  isHTMLInputEvent(event) && event.currentTarget
    ? event.target === event.currentTarget
    : true

export const getValuesFromEvent = (args: any[]) =>
  args.map((event) => {
    if (typeof event?.target !== 'object' || !event?.target) return event
    else if (event.target?.value !== undefined) return event.target.value
    else if (event.target?.checked === undefined) {
      return
    } else {
      return event.target.checked
    }
  })

export const getEventValues = (event: any, args: any[]) =>
  isHTMLInputEvent(event)
    ? getValuesFromEvent([event].concat(args))
    : [event].concat(args)
